export const topics = [
  {
    id: "topic-suspense",
    title: "悬疑剧场：一口气刷完的高能罪案剧",
    description: "从都市旧案到刑侦档案，精选氛围扎实、反转不断的悬疑作品，适合周末一次性追完。",
    reason: "剧情环环相扣、节奏紧凑，越看越上头。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20theme%20banner%2C%20foggy%20dark%20city%20with%20detectives%20and%20case%20files%20under%20lamps%2C%20deep%20navy%20blue%20with%20warm%20orange%20accents%2C%20moody%20atmospheric%20lighting%2C%20artistic%20film%20style%2C%20no%20text&width=1000&height=600&seq=topic-suspense&orientation=landscape",
    dramaIds: ["mu-se-hui-sheng", "wu-sheng-zhi-cheng", "mi-wu-dang-an"],
  },
  {
    id: "topic-scifi",
    title: "科幻与奇幻：在想象里抵达另一个世界",
    description: "跨越深海与星际，穿梭东方秘境，用最盛大的画面讲述人类最柔软的情感。",
    reason: "视觉震撼，脑洞与深情兼得。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20fantasy%20theme%20banner%2C%20cosmic%20nebula%20meets%20mystic%20mountains%20and%20deep%20sea%2C%20deep%20navy%20with%20warm%20orange%20and%20gold%20glow%2C%20cinematic%20dramatic%20atmosphere%2C%20artistic%20style%2C%20no%20text&width=1000&height=600&seq=topic-scifi&orientation=landscape",
    dramaIds: ["xing-chen-zhi-yue", "shen-hai-deng-ta", "shan-hai-huan-meng-lu"],
  },
  {
    id: "topic-urban",
    title: "都市群像：在别人的故事里看见自己",
    description: "职场、梦想与情感交织的城市故事，写给每一个正在努力生活的普通人。",
    reason: "真实细腻，代入感极强。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20theme%20banner%2C%20city%20skyline%20at%20dusk%20with%20people%20silhouettes%20and%20warm%20windows%2C%20deep%20navy%20blue%20with%20warm%20orange%20accents%2C%20cinematic%20atmosphere%2C%20artistic%20style%2C%20no%20text&width=1000&height=600&seq=topic-urban&orientation=landscape",
    dramaIds: ["mei-gui-yu-jing-ji", "ni-liu-er-shang", "zhui-guang-zhe"],
  },
  {
    id: "topic-nostalgia",
    title: "年代温情：把回家拍成一首长诗",
    description: "老铁路、旧车站与山城的灯火，那些跨越时代的故事，总能在某个瞬间击中你。",
    reason: "温暖治愈，看完想给家人打个电话。",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20period%20drama%20theme%20banner%2C%20old%20railway%20and%20mountain%20town%20at%20golden%20sunset%2C%20warm%20amber%20and%20muted%20navy%20tones%2C%20emotional%20cinematic%20artistic%20style%2C%20no%20text&width=1000&height=600&seq=topic-nostalgia&orientation=landscape",
    dramaIds: ["yun-shang-gui-tu", "tie-dao-wang-shi", "chun-feng-du-chang-an"],
  },
];